export default __webpack_public_path__ + "static/media/Kadabra.35ae2770.svg";